import React from "react";
import { motion } from "framer-motion";

/**
 * TableOfContents – Jump-link navigation for long-form homepage content.
 * Improves UX (users can jump to sections) and SEO (internal linking, dwell time).
 * Placed after the Hero section to orient visitors.
 */
export default function TableOfContents() {
  const sections = [
    { id: "what-are-green-gas-turbines", label: "What Are Green Gas Turbines?" },
    { id: "features", label: "Features & Benefits" },
    { id: "how-it-works", label: "How Green Gas Turbines Work" },
    { id: "green-vs-conventional", label: "Green vs. Conventional Turbines" },
    { id: "about", label: "Why GreenGasTurbines?" },
    { id: "latest-articles", label: "Latest Articles" },
    { id: "faq", label: "Frequently Asked Questions" },
    { id: "quote", label: "Get a Quote" },
  ];

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section className="py-12 bg-gradient-to-b from-primary-900 to-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.nav
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          aria-label="Table of contents"
          className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6 md:p-8"
        >
          <h2 className="text-lg font-bold text-secondary-900 mb-4">
            On This Page
          </h2>
          <ol className="grid grid-cols-1 sm:grid-cols-2 gap-2">
            {sections.map((s, idx) => (
              <li key={s.id}>
                <button
                  onClick={() => scrollTo(s.id)}
                  className="w-full text-left flex items-start gap-3 rounded-lg px-3 py-2 text-sm text-secondary-600 hover:bg-primary-50 hover:text-primary-700 transition-colors"
                >
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-100 text-primary-700 text-xs font-bold flex items-center justify-center mt-0.5">
                    {idx + 1}
                  </span>
                  <span>{s.label}</span>
                </button>
              </li>
            ))}
          </ol>
        </motion.nav>
      </div>
    </section>
  );
}
